var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.part=='description')?_c('editor-content',{attrs:{"editor":_vm.editorDescription}}):_c('editor-content',{attrs:{"editor":_vm.editorChecklist}})
}
var staticRenderFns = []

export { render, staticRenderFns }